import axios from "axios";

const TENANT_NOT_INITIALIZED_ERROR = "Tenant base URL is not initialized";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("access-token")}`,
});

const getTenantBaseUrl = () => {
  const tenantBaseUrl = window._store.getState().tenant.tenantBaseUrl;
  if (!tenantBaseUrl) {
    throw new Error(TENANT_NOT_INITIALIZED_ERROR);
  }
  return tenantBaseUrl;
};

export const fetchWrapper = {
  get: async (endpoint = "") => {
    const tenantBaseUrl = getTenantBaseUrl();
    const { data } = await axios.get(`${tenantBaseUrl}/api${endpoint}`);
    return data;
  },

  post: async (endpoint, postData, useAuth = true) => {
    const headers = useAuth ? getAuthHeaders() : {};
    const tenantBaseUrl = getTenantBaseUrl();
    const { data } = await axios.post(
      `${tenantBaseUrl}/api${endpoint}`,
      postData,
      {
        headers,
      }
    );
    return data;
  },

  put: async (endpoint, postData, useAuth = true) => {
    const headers = useAuth ? getAuthHeaders() : {};
    const tenantBaseUrl = getTenantBaseUrl();
    const { data } = await axios.post(
      `${tenantBaseUrl}/api${endpoint}`,
      postData,
      {
        headers,
      }
    );
    return data;
  },
};
